import React from 'react';
import PropTypes from 'prop-types';

const DeleteDefinition = props => {
  return (
    <div
      className="autocode-delete-definition"
      data-test="definitionDeleteComponent"
    >
      <button type="button" onClick={props.onDelete}>
        Delete
      </button>
    </div>
  );
};

DeleteDefinition.propTypes = {
  onDelete: PropTypes.func,
};

export default DeleteDefinition;
